import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { ApiHttpService } from '../../../shared/api/api-http.service'
import {
  DuplicateKnowledgeBasePayload,
  KnowledgeBase,
  KnowledgeBasesPage,
  NewKnowledgeBasePayload,
} from '../models/knowledge-base.entity'

type CheckConnectionPayload = {
  name: string
  description: string
  type: string
  app_version_id: string
  application_id: string
  additional_props: any
}

export type EmbedderInfo = {
  id: string
  label: string
  provider: string
  dimension: number
  dense: boolean
  sparse: boolean
}

export type EmbeddersResponse = {
  default: string
  embedders: EmbedderInfo[]
}

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseApi extends ApiHttpService {
  #url = 'agent-builder/api/v1/knowledge-bases'

  constructor() {
    super(inject('BASE_URL' as any), inject(HttpClient))
  }
  createKnowledgeBase(knowledgeBase: NewKnowledgeBasePayload): Observable<KnowledgeBase> {
    return this.post(`${this.#url}`, knowledgeBase)
  }
  duplicateKnowledgeBase(knowledgeBase: DuplicateKnowledgeBasePayload): Observable<KnowledgeBase> {
    return this.post(`${this.#url}/duplicate`, knowledgeBase)
  }
  getKnowledgeBases(): Observable<KnowledgeBasesPage> {
    return this.get(`${this.#url}`)
  }
  getKnowledgeBasesByApplicationId(applicationId: string): Observable<KnowledgeBasesPage> {
    return this.get(`${this.#url}/filtered/${applicationId}`)
  }
  getKnowledgeBaseById(knowledgeBaseId: KnowledgeBase['id']): Observable<KnowledgeBase> {
    return this.get(`${this.#url}/${knowledgeBaseId}`)
  }

  getEmbedders(): Observable<EmbeddersResponse> {
    return this.get(`${this.#url}/embedders`)
  }

  updateKnowledgeBase(knowledgeBase: KnowledgeBase): Observable<KnowledgeBase> {
    return this.patch(`${this.#url}/${knowledgeBase.id}`, knowledgeBase)
  }
  deleteKnowledgeBase(knowledgeBaseId: KnowledgeBase['id']): Observable<void> {
    return this.delete(`${this.#url}/${knowledgeBaseId}`, {})
  }
  checkConnection(knowledgeBase: CheckConnectionPayload): Observable<any> {
    return this.post(`${this.#url}/check-connection`, knowledgeBase)
  }
  searchDocuments(knowledgeBaseId: KnowledgeBase['id'], query: string): Observable<any> {
    return this.post(`${this.#url}/${knowledgeBaseId}/documents`, { query })
  }
  uploadDocument(knowledgeBaseId: KnowledgeBase['id'], formData: FormData): Observable<any> {
    return this.post(`${this.#url}/${knowledgeBaseId}/upload`, formData)
  }

  deleteDocument(knowledgeBaseId: KnowledgeBase['id'], filename: string): Observable<any> {
    return this.delete(`${this.#url}/${knowledgeBaseId}/documents`, { body: { filename } })
  }
}
